<!-- 召回通知单列表 -->
<template>
    <div>
        <subComponents ref="showSelectData"></subComponents>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs v-if="tabForm" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }"
                            @tabHeight="(val) => { mxHeight = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form class="baseForm" id="mainInfo" label-width="100px" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false" :inline-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2">
                                            <el-form-item v-if="formOneValue.isShow == 1&&formOneValue.entityField!='storeAddress'&&formOneValue.entityField!='memDay'&&formOneValue.entityField!='storeManrange'" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" :label="formOneValue.showField"
                                                          :prop="formOneValue.entityField"
                                                          :rules="formOneValue.isRequired == 1 ? [{ required: true, message: formOneValue.showField + '不能为空', trigger: ['blur', 'change'] }] : []">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                <!-- 检索方案 -->
                                                <el-tooltip v-if="formOneValue.fieldType == 'search'" class="item"
                                                            :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                            effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                    <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                              @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                                              :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                        <el-button @click="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)" slot="append"
                                                                   icon="el-icon-search" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                        </el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" :disabled="formOneValue.isChange == 0" @visible-change="selectChange"
                                                           v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                    <el-option v-for="(matItem,index) in JSON.parse(formOneValue.formatterContent)" :key="index" :label="String(Number(matItem.key)) == 'NaN' ? matItem.key : matItem.value"
                                                               :value="String(Number(matItem.key)) == 'NaN' ? matItem.value : matItem.key"></el-option>
                                                </el-select>
                                                <el-date-picker v-else-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日"
                                                                value-format="timestamp">
                                                </el-date-picker>
                                                <el-input class="form_codition" v-else type="text" @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)"
                                                          v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength" :disabled="formOneValue.isChange == 0"></el-input>
                                            </el-form-item>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                                <span v-if="formOneValue.isRift == 1">
                                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField] }}</a>
                                                </span>
                                                <span v-else-if="formOneValue.fieldType == 'date'">
                                                    <span v-if="sendDataInfo[formOneValue.entityField]">
                                                        {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                                    </span>
                                                </span>
                                                <span v-else-if="formOneValue.fieldType == 'formatter'">
                                                    {{ getValue(sendDataInfo[formOneValue.entityField], formOneValue.entityField,formOneValue.fieldType, formOneValue.formatterContent) }}
                                                </span>
                                                <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>
                                    <el-form size="mini" :model="sendDataInfo" label-width="100px" ref="sendDataInfo1" :show-message="false">
                                        <el-form-item v-if="rulesObj['storeAddress'].isShow==1" label="门店地址" prop="storeAddress" :rules="rulesObj['storeAddress'].required?[{required: true, trigger: ['blur', 'change']}]:[]">
                                            <label slot="label" :style="$common.labelStyle('门店地址')" v-html="$common.htmlLabel('门店地址')"></label>
                                            <el-input type="textarea" style="min-width: 600px !important" v-model.trim="sendDataInfo.storeAddress" :maxlength="$store.state.inputLength" placeholder="填写门店地址"></el-input>
                                        </el-form-item>
                                        <el-form-item v-if="rulesObj['memDay'].isShow==1" label="会员日" prop="memDay" :rules="rulesObj['memDay'].required?[{required: true, trigger: ['blur', 'change']}]:[]">
                                            <label slot="label" :style="$common.labelStyle('会员日')" v-html="$common.htmlLabel('会员日')"></label>
                                            <div id="smManrange">
                                                <div class="cmContent">
                                                    <el-button class="cmButton" @click="openRange('会员日', 'memDay')" type="info" plain size="mini">选择会员日</el-button>
                                                    <el-input type="textarea" v-model="obj.memDayValues" readonly>
                                                    </el-input>
                                                </div>
                                            </div>
                                        </el-form-item>
                                        <el-form-item v-if="rulesObj['storeManrange'].isShow==1" label="经营范围" prop="storeManrange" :rules="rulesObj['storeManrange'].required?[{required: true, trigger: ['blur', 'change']}]:[]">
                                            <label slot="label" :style="$common.labelStyle('经营范围')" v-html="$common.htmlLabel('经营范围')"></label>
                                            <div class="cmContent">
                                                <el-button class="cmButton" @click="openRange('经营范围', 'smManrange')" type="info" plain size="mini">选择经营范围</el-button>
                                                <el-input type="textarea" v-model="obj.smManrangeValues" readonly>
                                                </el-input>
                                            </div>
                                        </el-form-item>
                                    </el-form>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
            </div>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 范围穿梭框 -->
        <el-dialog :title="'选择' + rangeTitle" :visible.sync="dialogRange" width="70%" :modal-append-to-body="true" id="csDia" :append-to-body="true" :before-close="handleClose">
            <!-- 会员日类型选择 -->
            <div v-if="rangeTitle === '会员日'" style="margin-bottom: 15px">
                <label slot="label" :style="$common.labelStyle('会员日类型:')" v-html="$common.htmlLabel('会员日类型:')"></label>
                <el-select v-model="tempMemDayType" placeholder="请选择会员日类型" @change="handleMemDayTypeChange" style="width: 200px">
                    <el-option label="周" value="1"></el-option>
                    <el-option label="日" value="2"></el-option>
                </el-select>
            </div>
            <div class="edit_dev">
                <el-transfer filterable v-if="dialogRange" :filter-method="filterMethod" target-order="push" filter-placeholder="请输入范围名称" v-model="rangeValue" :titles="['未选择', '已选择']" :data="transferData">
                </el-transfer>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="confirmRange">确 定</el-button>
            </span>
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue"
import NP from "number-precision";
export default {
    name: "storeModal",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {},
            detaislDataInfo: {},
            showTabs: "",
            formDataList: [],
            DialogVisible: false,
            seTitle: "",
            seWidth: "",
            seId: "",
            seType: "",
            seIndex: "",
            sField: "", // 赋值字段
            fField: "", //焦点字段
            parentSearchData: {},
            mxHeight: 0,
            tabForm: [],
            mxForm: [],
            footForm: [],
            requesUrl: "",
            token: {
                token: sessionStorage.getItem("token"),
            },
            inputel: [],
            //----------------
            rangeValue: [],
            transferData: [], //穿梭框数据
            rangeTitle: "",
            dialogRange: false,
            rangeNum: 0,
            smManrangeIds: [], // 经营范围已选择范围Id
            smManrangeList: [], // 经营范围数据
            obj: {
                smManrangeValues: "", // 经营范围已选择范围名称
                storeManrange: "",
                memDayValues: "", // 会员日已选择范围名称
            },
            memDayIds: [], // 会员日已选择范围Id
            memDayList: [], // 会员日数据
            memDayDisplay: "",
            memDayDialog: false,
            tempMemDayType: "",
            tempMemDayArray: [],
            memDayTypeDialog: false,
            rulesObj:{
                storeManrange:{//店长范围
                    required:false,
                    isShow:0,
                },
                storeAddress:{//门店地址
                    required:false,
                    isShow:0,
                },
                memDay:{//会员日
                    required:false,
                    isShow:0,
                }
            }
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        // 是否确认关闭
        handleClose(done) {
            this.$confirm("关闭弹窗将删除已选择的范围，确认关闭？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.dialogRange = false
                })
                .catch(() => { })
        },
        // 主表单select框切换enter切换焦点事件方法
        selectChange(e) {
            if (e == false) {
                for (let index = 0; index < this.inputel.length; index++) {
                    if (this.inputel[index] == document.activeElement) {
                        this.nextFocus(index);
                        break;
                    }
                }
            }
        },
        imgur() {
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
        showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        changeInputModel(val) {
            this.DialogVisible = false;
            if (val && (val != "" || val != undefined)) {
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val, flag) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.$set(this.sendDataInfo, item, val[item])
            });
            this.$nextTick(() => {
                this.nextFocus(this.seIndex, this.fField);
            });
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField, fField) {
            this.parentSearchData = {}
            if (type == 'salesName') {
                if (this.sendDataInfo.cmId == '' || this.sendDataInfo.cmId == null) {
                    return this.$message.error("请先选择客户");
                }
                this.parentSearchData.unitId = this.sendDataInfo.cmId;
            }
            if (type == 'opmName') {
                this.parentSearchData.opmSalesperson = 1
                this.parentSearchData.opmBuyer = ""
            }
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.fField = fField;
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },


        initActionBox(sendDataInfo) {
            this.$confirm("确定取消新增吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.$emit("drawerCancel", 0);
                this.init();
                this.$refs.sendDataInfo.resetFields();
            }).catch(() => { });
        },
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
        },

        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            var oldData = this.actionData.oldData;
            this.showTabs = this.actionData.formData[0].jciName;
            this.filterMainField();
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
                this.sendDataInfo.rcnId = dataInfo.rcnId
                // 回显数据
                if (this.actionData.oldData) {
                    for (let key in this.actionData.oldData) {
                        // 特殊处理会员日类型
                        if (key === "memDayType") {
                            this.$set(this.sendDataInfo, key, this.actionData.oldData[key] !== null && this.actionData.oldData[key] !== undefined ? this.actionData.oldData[key].toString() : "")
                        } else {
                            this.$set(this.sendDataInfo, key, this.actionData.oldData[key])
                        }
                    }
                    // 处理会员日数据
                    if (this.actionData.oldData.memDay) {
                        this.memDayIds = this.actionData.oldData.memDay.split(",").map(Number).filter(id => id > 0) // 过滤掉空值
                        // 设置会员日类型
                        if (this.actionData.oldData.memDayType) {
                            this.sendDataInfo.memDayType = this.actionData.oldData.memDayType.toString();
                        }
                        // 设置会员日名称
                        if (this.actionData.oldData.memDayName) {
                            this.obj.memDayValues = this.actionData.oldData.memDayName
                        } else {
                            this.updateMemDayDisplay() // 更新会员日显示
                        }
                        this.getMemDays() // 获取会员日数据
                    }
                    // 处理经营范围数据
                    if (this.actionData.oldData.storeManrange) {
                        this.smManrangeIds =
                            this.actionData.oldData.storeManrange.split(",")
                        // 设置经营范围名称
                        if (this.actionData.oldData.storeManrangeName) {
                            this.obj.smManrangeValues =
                                this.actionData.oldData.storeManrangeName
                        }
                        this.getRanges() // 获取经营范围数据
                    }
                    // 处理库房信息
                    if (this.actionData.oldData.stId) {
                        this.sendDataInfo.stId = this.actionData.oldData.stId
                        this.sendDataInfo.stName = this.actionData.oldData.stName
                    }
                    // 处理价格组信息
                    if (this.actionData.oldData.groupPriceId) {
                        this.sendDataInfo.groupPriceId = this.actionData.oldData.groupPriceId
                        this.sendDataInfo.groupName = this.actionData.oldData.groupName
                    }
                }
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight();
                    } else {
                        this.mxHeight = this.$common.getHeight();
                    }
                    this.initFocus();
                }, 16.7);
            });
        },

        // 获取经营范围
        async getQueryScopeByType(type) {
            console.log(this.smManrangeIds)
            let ormId = sessionStorage.getItem("ormId")
            let params = {
                type: type,
                ormId: ormId,
            }
            //type 范围类型0.生产范围1.经营范围
            let responseData = await this.$http.queryScopeByType(params)
            if (responseData.status == 200) {
                if (type == 1) {
                    this.smManrangeList = responseData.result
                    if (this.dataActionBox.actionType != 0) {
                        var value1 = []
                        if (this.smManrangeIds && this.smManrangeIds.length > 0) {
                            console.log(this.smManrangeIds, "ceshi")
                            console.log(this.smManrangeList, "ceshi")
                            this.smManrangeIds.forEach((val) => {
                                if (this.smManrangeList.length > 0) {
                                    if (
                                        this.smManrangeList.filter((item) => item.discId == val)
                                            .length > 0
                                    ) {
                                        value1.push(
                                            this.smManrangeList.filter(
                                                (item) => item.discId == val
                                            )[0].scopeName
                                        )
                                    }
                                }
                            })
                        }
                        this.obj.smManrangeValues = value1.toString()
                    }
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                })
            }
        },
        // 打开选择范围
        openRange(title, type) {
            this.rangeValue = []
            this.transferData = []
            this.rangeTitle = title
            if (type == "smManrange") {
                this.rangeNum = 1
                if (this.smManrangeIds.length > 0) {
                    this.rangeValue = this.smManrangeIds.map(Number)
                }
                this.smManrangeList.forEach((item) => {
                    this.transferData.push({
                        label: item.scopeName,
                        key: item.discId,
                        pinyin: item.scopeCode,
                    })
                })
            } else if (type == "memDay") {
                this.rangeNum = 2
                this.tempMemDayType = this.sendDataInfo.memDayType || "1" // 默认选择周 
                // 根据类型生成数据
                this.generateMemDayData()
                // 设置已选择的值
                if (this.memDayIds.length > 0) {
                    this.rangeValue = this.memDayIds.map(Number)
                }
            } else if (type == "memDayWeek") {
                this.rangeNum = 3
                if (this.memDayIds.length > 0) {
                    this.rangeValue = this.memDayIds.map(Number)
                }
                // 只显示周选择数据
                const weekDays = [
                    { dayId: 1, dayName: "星期一", dayCode: "monday" },
                    { dayId: 2, dayName: "星期二", dayCode: "tuesday" },
                    { dayId: 3, dayName: "星期三", dayCode: "wednesday" },
                    { dayId: 4, dayName: "星期四", dayCode: "thursday" },
                    { dayId: 5, dayName: "星期五", dayCode: "friday" },
                    { dayId: 6, dayName: "星期六", dayCode: "saturday" },
                    { dayId: 7, dayName: "星期日", dayCode: "sunday" },
                ]
                weekDays.forEach((item) => {
                    this.transferData.push({
                        label: item.dayName,
                        key: item.dayId,
                        pinyin: item.dayCode,
                    })
                })
            } else if (type == "memDayMonth") {
                this.rangeNum = 4
                if (this.memDayIds.length > 0) {
                    this.rangeValue = this.memDayIds.map(Number)
                }
                // 只显示日选择数据（1-31号）
                for (let i = 1; i <= 31; i++) {
                    this.transferData.push({
                        label: `${i}号`,
                        key: i, // 直接用1-31
                        pinyin: `day${i}`,
                    })
                }
            }
            this.dialogRange = true
        },
        // 选择范围确定
        confirmRange() {
            if (this.rangeNum == 1) {
                this.smManrangeIds = this.rangeValue //经营范围
                var value1 = []
                this.smManrangeIds.forEach((val) => {
                    if (this.smManrangeList.length > 0) {
                        if (
                            this.smManrangeList.filter((item) => item.discId == val).length >
                            0
                        ) {
                            value1.push(
                                this.smManrangeList.filter((item) => item.discId == val)[0]
                                    .scopeName
                            )
                        }
                    }
                })
                this.obj.smManrangeValues = value1.toString()
            } else if (this.rangeNum == 2) {
                this.memDayIds = this.rangeValue //会员日
                this.sendDataInfo.memDayType = this.tempMemDayType

                if (this.memDayIds.length === 0) {
                    // 没有选择任何数据，显示为空
                    this.obj.memDayValues = ""
                } else if (this.tempMemDayType === "1") {
                    // 周选择
                    const weekMap = {
                        1: "星期一",
                        2: "星期二",
                        3: "星期三",
                        4: "星期四",
                        5: "星期五",
                        6: "星期六",
                        7: "星期日",
                    }
                    const dayText = this.memDayIds
                        .map((val) => weekMap[val])
                        .filter(Boolean)
                        .join(", ")
                    this.obj.memDayValues = `周：${dayText}`
                } else if (this.tempMemDayType === "2") {
                    // 日选择，直接用val
                    const dayText = this.memDayIds
                        .map((day) => `${day}号`)
                        .filter((day) => {
                            const dayNum = parseInt(day.replace('号', ''));
                            return dayNum >= 1 && dayNum <= 31;
                        })
                        .join(", ")
                    this.obj.memDayValues = `日：${dayText}`
                }

                // 更新会员日数据
                this.sendDataInfo.memDay = this.memDayIds.join(",")
            } else if (this.rangeNum == 3) {
                this.memDayIds = this.rangeValue //会员日-周
                var value3 = []
                const weekMap = {
                    1: "星期一",
                    2: "星期二",
                    3: "星期三",
                    4: "星期四",
                    5: "星期五",
                    6: "星期六",
                    7: "星期日",
                }
                this.memDayIds.forEach((val) => {
                    if (weekMap[val]) {
                        value3.push(weekMap[val])
                    }
                })
                this.obj.memDayValues = `周：${value3.join(", ")}`
                // 更新会员日数据
                this.sendDataInfo.memDay = this.memDayIds.join(",")
            } else if (this.rangeNum == 4) {
                this.memDayIds = this.rangeValue //会员日-日
                var value4 = []
                this.memDayIds.forEach((val) => {
                    if (val >= 1 && val <= 31) {
                        value4.push(`${val}号`)
                    }
                })
                this.obj.memDayValues = `日：${value4.join(", ")}`
                // 更新会员日数据
                this.sendDataInfo.memDay = this.memDayIds.join(",")
            }
            this.dialogRange = false
        },
        getRanges() {
            // //type 范围类型0.生产范围1.经营范围2.诊疗范围
            this.getQueryScopeByType(1)
        },
        // 获取会员日数据
        getMemDays() {
            // 如果是编辑模式，设置已选择的会员日显示
            if (this.dataActionBox.actionType != 0 && this.memDayIds.length > 0) {
                this.updateMemDayDisplay()
            }
        },
        // 更新会员日显示文本
        updateMemDayDisplay() {
            if (!this.sendDataInfo.memDayType || !this.memDayIds.length) {
                this.obj.memDayValues = ""
                return
            }

            if (this.memDayIds.length === 0) {
                // 没有选择任何数据，显示为空
                this.obj.memDayValues = ""
            } else if (this.sendDataInfo.memDayType === "1") {
                // 周选择
                const weekMap = {
                    1: "星期一",
                    2: "星期二",
                    3: "星期三",
                    4: "星期四",
                    5: "星期五",
                    6: "星期六",
                    7: "星期日",
                }
                const dayText = this.memDayIds
                    .map((day) => weekMap[day])
                    .filter(Boolean)
                    .join(", ")
                this.obj.memDayValues = `周：${dayText}`
            } else if (this.sendDataInfo.memDayType === "2") {
                // 日选择，直接用val
                const dayText = this.memDayIds
                    .map((day) => `${day}号`)
                    .filter((day) => {
                        const dayNum = parseInt(day.replace('号', ''));
                        return dayNum >= 1 && dayNum <= 31;
                    })
                    .join(", ")
                this.obj.memDayValues = `日：${dayText}`
            }
        },
        handleMemDayTypeChange() {
            // 处理会员日类型变化后的逻辑
            this.sendDataInfo.memDayType = this.tempMemDayType
            this.rangeValue = [] // 清空已选择的值
            this.generateMemDayData()
        },
        // 生成会员日数据
        generateMemDayData() {
            this.transferData = []
            if (this.tempMemDayType === "1") {
                // 周选择
                const weekMap = {
                    1: "星期一",
                    2: "星期二",
                    3: "星期三",
                    4: "星期四",
                    5: "星期五",
                    6: "星期六",
                    7: "星期日",
                }
                for (let i = 1; i <= 7; i++) {
                    this.transferData.push({
                        label: weekMap[i],
                        key: i,
                        pinyin: `week${i}`,
                    })
                }
            } else if (this.tempMemDayType === "2") {
                // 日选择，key用1-31
                for (let i = 1; i <= 31; i++) {
                    this.transferData.push({
                        label: `${i}号`,
                        key: i,
                        pinyin: `day${i}`,
                    })
                }
            }
        },
        sendDataAction(sendDataInfo) {
            console.log(sendDataInfo);
            this.$refs.sendDataInfo.validate((valid) => {
                if (valid) {
                    this.$refs.sendDataInfo1.validate((valid) => {
                        if (valid) {
                            this.sub();
                        } else {
                            this.$message({
                                message: "请完善主表单必填信息",
                                type: "error",
                            });
                            return false;
                        }
                    });
                } else {
                    this.$message({
                        message: "请完善主表单必填信息",
                        type: "error",
                    });
                    return false;
                }
            });
        },
        async sub() {
            // 处理会员日数据
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
            // 将经营范围ID数组转换为逗号分隔的字符串
            sendData.storeManrange = this.smManrangeIds.join(",")
            try {
                let responseData
                // 如果是新增
                if (this.dataActionBox.actionType == 0) {
                    responseData = await this.$http.addstore(sendData)
                }
                // 如果是编辑
                else if (this.dataActionBox.actionType == 1) {
                    responseData = await this.$http.updatestore(sendData)
                }

                if (responseData.status == 200) {
                    this.$message({
                        message: this.dataActionBox.actionType == 0 ? "新增成功" : "编辑成功",
                        type: "success",
                    })
                    this.$emit("drawerCancel", 1)
                    this.$emit("toDetail", responseData.result)
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    })
                }
            } catch (error) {
                console.error("error", error)
                this.$message({
                    message: "操作失败",
                    type: "error",
                })
            }
        },
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (type == 'bgiType' || fieldType == 'formatter') {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value == val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key == val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
                    this.mxForm.forEach((item1) => {
                        if (item1.fieldType == "number") {
                            this.$set(this.detaislDataInfo, item1.entityField, 0);
                        } else if (item1.fieldType == "search" && item1.setField) {
                            var arr = item1.setField.split(",");
                            arr.forEach((item2) => {
                                this.$set(this.detaislDataInfo, item2, "");
                            });
                        } else {
                            this.$set(this.detaislDataInfo, item1.entityField, "");
                        }
                    });

                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                var index1 = 0
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    // if (key.jurconfigform[index].isShow == 1)
                    if (key.jurconfigform[index].isShow == 1) {
                        key.jurconfigform[index].isIndex = index1
                        index1++
                    }
                    if (key.jurconfigform[index].entityField=='storeManrange'||key.jurconfigform[index].entityField=='storeAddress'||key.jurconfigform[index].entityField=='memDay') {
                        this.rulesObj[key.jurconfigform[index].entityField].required=key.jurconfigform[index].isRequired==1?true:false
                        this.rulesObj[key.jurconfigform[index].entityField].isShow=key.jurconfigform[index].isShow
                    }
                    this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);

                }
            });
            var arr = [];
            var obj = this.$common.filterMainFields(
                this.formDataList,
                arr,
                mainFormList[0]
            );
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key]);
            }
        },
        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == "") {
                    this.inputel[index].focus();
                    break;
                }
            }
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById("mainInfo");
            if (el) this.inputel = el.getElementsByTagName("input");
        },
        // 输入框切换焦点
        nextFocus(index, fField) {
            if (fField == "keydown") {
                return;
            }
            var aindex = index + 1;
            if (
                this.inputel[aindex].value != "" ||
                this.inputel[aindex].disabled
            ) {
                this.nextFocus(aindex);
                return;
            }
            this.$nextTick(() => {
                this.inputel[aindex].focus();
            });
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.imgur();
        this.$nextTick(() => {
            this.openBox();
            this.getRanges()
            this.getMemDays()
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput();
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
    margin-bottom: 0;
}
.cmContent {
    width: 90%;
}

.mem-day-type-content {
    text-align: center;
    padding: 20px 0;
}

.mem-day-type-content .el-radio {
    margin: 0 20px;
    font-size: 16px;
}

.mem-day-content {
    max-height: 400px;
    overflow-y: auto;
}

.mem-day-content p {
    margin-bottom: 15px;
    font-weight: bold;
    color: #333;
}

.mem-day-content .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.mem-day-content .el-checkbox {
    margin-right: 15px;
    margin-bottom: 10px;
    min-width: 80px;
}

.mem-day-type-section {
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #eee;
}

.mem-day-type-section h4 {
    margin-bottom: 10px;
    color: #333;
    font-size: 14px;
}

.mem-day-type-section .el-radio {
    margin-right: 20px;
    font-size: 14px;
}

.mem-day-detail-section h4 {
    margin-bottom: 15px;
    color: #333;
    font-size: 14px;
}

.dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background: #fff;
    height: 46px;
    padding: 5px 10px;
    margin-top: 20px;
    border-top: 1px solid #eee;
}
</style>